import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import StarIcon from "@mui/icons-material/Star";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, IconButton, Switch, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { putRoleById } from "../../../api/broker";
import { useSuperAdminRoles } from "../../../context/SuperAdmin/RolesContext";
import { useAuthContext } from "../../../hooks/Auth";
import { Estado } from "../../../interfaces/SuperAdmin/Others/iDataEstado";
import {
  EditRoleFields,
  iDataRoles,
} from "../../../interfaces/SuperAdmin/Pages/iDataRoles";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";
import { formatFechaWithHour } from "../../../utils/dateFunctions";

interface RoleRowProps {
  role: iDataRoles;
  i: number;
}

const ProfileRowRole: React.FC<RoleRowProps> = ({ role, i }) => {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(role.estado === Estado.ACTIVO);
  const { openModal } = useSuperAdminRoles();
  const { canAccess } = useAuthContext();

  const handleDelete = () => {
    openModal(role.id_rol);
  };

  const toggleActive = async () => {
    const body = { estado: isActive ? Estado.INACTIVO : Estado.ACTIVO };

    try {
      const res = await putRoleById(body as EditRoleFields, role.id_rol);
      console.log(res);

      if (res.status === 200) {
        setIsActive((prev) => !prev);
        toast.success(
          `Rol ${isActive ? "desactivado" : "activado"} exitosamente`
        );
      } else {
        toast.error(`Error al  ${isActive ? "desactivar" : "activar"} el rol`);
      }
    } catch (error) {
      console.log(error);
      toast.error(`Error al  ${isActive ? "desactivar" : "activar"} el rol`);
    }
  };

  return (
    <StyledTableRow>
      <StyledTableCell align="center" sx={{ mb: 2 }}>
        {i}
      </StyledTableCell>
      <StyledTableCell align="center" sx={{ mb: 4 }}>
        <Typography
          component={"div"}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
          }}
        >
          {!role.es_editable && <StarIcon />}
          {role.nombre}
        </Typography>
      </StyledTableCell>
      <StyledTableCell align="center">
        {formatFechaWithHour(role.created_at)}
      </StyledTableCell>
      {canAccess("edit:role") && (
        <StyledTableCell align="center">
          <Switch
            checked={isActive}
            onChange={toggleActive}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "#2E7D32",
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#2E7D32",
              },
            }}
          />
        </StyledTableCell>
      )}
      <StyledTableCell align="center">
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => navigate(`${role.id_rol}`)}
        >
          <Tooltip title="Ver rol">
            <IconButton aria-label="rol" sx={{ color: "#336B87" }}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Button>
        {role.es_editable && canAccess("delete:role") && (
          <Button sx={{ color: "#336B87" }} onClick={handleDelete}>
            <Tooltip title="Eliminar rol">
              <IconButton aria-label="delete" sx={{ color: "#336B87" }}>
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Button>
        )}
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default ProfileRowRole;
